module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/setting/setting.component.html
// module id = ../../../../../src/app/dashboard/pages/setting/setting.component.html
// module chunks = main